module.exports = __WEBPACK_EXTERNAL_MODULE_1242__;


//////////////////
// WEBPACK FOOTER
// external "jQuery"
// module id = 1242
// module chunks = 0